module.exports = __webpack_public_path__ + "media/icons/drzwi@2x-efdfccdd.png";